import { ofType} from 'redux-observable';
import { map, mapTo} from 'rxjs/operators';
import {RDX_NAV_NAVIGATE} from '../redux/navAction';
import history from '../app/history';

const navEpic = (action$) => action$.pipe(
	ofType(RDX_NAV_NAVIGATE),
	map(
		(action) => {
			history.push('/' + action.target);
		}
	),
	mapTo(
		{type: 'rdx/Done'}
	)
);
export default navEpic;
